import { Tooltip } from "antd";

interface AlvosTagProps {
  alvos: any[];
}

function AlvosTag({ alvos }: AlvosTagProps) {
  return (
    <Tooltip title={
      <>
        {alvos?.map(alvo => (
          <p>{alvo?.alvo}</p>
        ))}
      </>
    }>
      <span>
        {alvos.length > 0 && alvos[0]?.alvo} {alvos.length > 1 && `(+${alvos.length - 1})`}
      </span>
    </Tooltip>
  );
}

export default AlvosTag;
